export enum DeviceSubscriptionState {
  CURRENT = 'Current',
  EXPIRED = 'Expired',
  NONE = 'None'
}
